// adsCampaingManagment


export interface AdsCampaign
 {
  id                           : number         ,
  creationDate                 : Date           ,
  reference                    : string         ,
  agentId                      : number         ,
  totalPriceWithoutTax         : number         ,
  totalPriceWithTax            : number         ,
  taxRate                      : string         ,
  legalStructureId             : number         ,
  beginningDate                : Date | null    ,
  endingDate                   : Date | null    ,
  name                         : string         ,
  channelId                    : number         ,
  areaId                       : number         ,
  advertisingSpotsNumberPerDay : number         , 
  spotDuration                 : number         ,
  schedule                     : Date[]         ,
  adSpotId                     : number      
 }
 
export const initializedAdsCampaign = (): AdsCampaign => (
 {
  id                     : 0          ,
  creationDate           : new Date() ,
  reference              : ''         ,
  agentId                : 0          ,
  totalPriceWithoutTax   : 0          ,
  totalPriceWithTax      : 0          ,
  taxRate                : '20%'      ,  
  legalStructureId       : 0          ,
  beginningDate          : null       ,
  endingDate             : null       ,
  name                   : ''         ,
  channelId              : 0          ,
  areaId                 : 0          ,
  advertisingSpotsNumberPerDay : 0         , 
  spotDuration                 : 0         ,
  schedule               : []         ,
  adSpotId                : 0      
});

